
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("9lnyC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("65c2R")).default);

var $65c2R = parcelRequire("65c2R");

});
parcelRegister("65c2R", function(module, exports) {
$parcel$export(module.exports, "default", () => $81392dea693523af$export$2e2bcd8739ae039);
/* view-homepage.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $6gAcU = parcelRequire("6gAcU");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $fxMO5 = parcelRequire("fxMO5");

var $j2vrN = parcelRequire("j2vrN");

var $jcRK7 = parcelRequire("jcRK7");

var $2ERPT = parcelRequire("2ERPT");

var $8gC0T = parcelRequire("8gC0T");

var $lFpPv = parcelRequire("lFpPv");

var $hO5qW = parcelRequire("hO5qW");

var $cywwP = parcelRequire("cywwP");

var $fuVmc = parcelRequire("fuVmc");

var $a7Tmb = parcelRequire("a7Tmb");

var $k30kR = parcelRequire("k30kR");

var $4vLTk = parcelRequire("4vLTk");

var $cJJTb = parcelRequire("cJJTb");

var $a2qIF = parcelRequire("a2qIF");

var $5lPCP = parcelRequire("5lPCP");

var $38uh5 = parcelRequire("38uh5");

var $44VoE = parcelRequire("44VoE");

var $aI0YR = parcelRequire("aI0YR");

var $ckGNT = parcelRequire("ckGNT");

var $1DDTY = parcelRequire("1DDTY");

var $eDJg6 = parcelRequire("eDJg6");

var $2Trol = parcelRequire("2Trol");

var $by4Mb = parcelRequire("by4Mb");

var $4D9kL = parcelRequire("4D9kL");

var $2Wp8Q = parcelRequire("2Wp8Q");

var $hKa9R = parcelRequire("hKa9R");

var $6f79M = parcelRequire("6f79M");

var $hMmMY = parcelRequire("hMmMY");

var $e9mOl = parcelRequire("e9mOl");

var $gQQJs = parcelRequire("gQQJs");

var $dwOcU = parcelRequire("dwOcU");

var $9ym5V = parcelRequire("9ym5V");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $iydAA = parcelRequire("iydAA");

var $iW3CQ = parcelRequire("iW3CQ");

var $51XYw = parcelRequire("51XYw");

var $51XYw = parcelRequire("51XYw");

var $3LQyI = parcelRequire("3LQyI");

var $a6PX2 = parcelRequire("a6PX2");

var $2aw7C = parcelRequire("2aw7C");

var $bwdOx = parcelRequire("bwdOx");

var $oORS9 = parcelRequire("oORS9");
parcelRequire("cNoX9");
var $BkxYp = parcelRequire("BkxYp");

var $fIqDf = parcelRequire("fIqDf");

var $7WRjA = parcelRequire("7WRjA");

var $3cWdD = parcelRequire("3cWdD");

var $7PmsI = parcelRequire("7PmsI");
const $81392dea693523af$var$ViewHomepage = ({ queryReference: queryReference, isCustomizing: isCustomizing, searchBarShown: searchBarShown, onStartEditing: onStartEditing, onFinishEditing: onFinishEditing, canAdministerJira: canAdministerJira })=>{
    var _data$helpLayout, _data$helpLayout4, _data$helpCenter, _data$helpCenter2, _data$helpLayout5;
    const intl = (0, $4vLTk.default)();
    const isSmallScreenSize = (0, $2Trol.useMediaQuery)(`(max-width: ${(0, $a7Tmb.sizes).small}px)`);
    const customiseSidebarTriggerRef = (0, $ckGNT.useCustomiseSidebarTriggerRef)();
    if (!(0, $fuVmc.isValidLayoutAriPresent)()) {
        // this is the initial docs call traceId we get from Jira
        const traceId = (0, $iW3CQ.getEnv)().traceId ?? '';
        throw new Error(`Invalid layout ari. EnvTraceId: ${traceId}`);
    }
    const data = (0, $a2qIF.usePreloadedQuery)((0, $6gAcU.default), queryReference);
    const onOpen = (0, $bSJIT.useCallback)(()=>{
        onStartEditing();
    }, [
        onStartEditing
    ]);
    const handleFinishEditing = (0, $bSJIT.useCallback)(()=>{
        (0, $2aw7C.clearSidebarExperienceAndCustomize)();
        onFinishEditing();
    }, [
        onFinishEditing
    ]);
    (0, $bSJIT.useEffect)(()=>{
        // We are marking the experience as success once the component mounts successfully. We are not using ExperienceSuccess in render because if  there is a error in useEffect, the experience will be wrongly marked as success even before hitting the error boundary.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $3cWdD.viewHomepageExperience).success();
    }, []);
    if ((data === null || data === void 0 || (_data$helpLayout = data.helpLayout) === null || _data$helpLayout === void 0 || (_data$helpLayout = _data$helpLayout.layout) === null || _data$helpLayout === void 0 ? void 0 : _data$helpLayout.__typename) === 'QueryError') {
        var _data$helpLayout2, _data$helpLayout3;
        const extensions = data === null || data === void 0 || (_data$helpLayout2 = data.helpLayout) === null || _data$helpLayout2 === void 0 ? void 0 : _data$helpLayout2.layout.extensions;
        const message = (data === null || data === void 0 || (_data$helpLayout3 = data.helpLayout) === null || _data$helpLayout3 === void 0 || (_data$helpLayout3 = _data$helpLayout3.layout) === null || _data$helpLayout3 === void 0 ? void 0 : _data$helpLayout3.message) || '';
        let statusCode = (0, $jcRK7.HTTP).SERVER;
        if (extensions && Array.isArray(extensions) && extensions.length > 0) // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        statusCode = extensions[0].statusCode;
        throw new (0, $51XYw.FetchError)(message, statusCode, true);
    }
    if (!(data !== null && data !== void 0 && (_data$helpLayout4 = data.helpLayout) !== null && _data$helpLayout4 !== void 0 && _data$helpLayout4.layout)) return null;
    const helpCenterName = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.name) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.default;
    const title = intl.formatMessage((0, $7PmsI.default).helpCenterTitle, {
        helpCenterTitle: helpCenterName
    });
    const showCustomizeSidebar = Boolean(data === null || data === void 0 || (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.announcements) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.canEditHomePageAnnouncement);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2ERPT.default), {
        title: title,
        ignoreBaseTitle: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $9ym5V.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($81392dea693523af$var$LayoutViewerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $e9mOl.LayoutViewRenderer), {
        layout: data === null || data === void 0 || (_data$helpLayout5 = data.helpLayout) === null || _data$helpLayout5 === void 0 ? void 0 : _data$helpLayout5.layout
    }), showCustomizeSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJJTb.LazySuspense), {
        fallback: null
    }, !searchBarShown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $ckGNT.LazyPushingCustomizeSidebar), {
        isOpen: isCustomizing,
        onOpen: onOpen,
        onClose: handleFinishEditing,
        triggerRef: customiseSidebarTriggerRef
    }, !isSmallScreenSize ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($81392dea693523af$var$HelpCenterBucketsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4D9kL.LazyHelpCenterBucketsRoutes), {
        isOpen: isCustomizing,
        onClose: handleFinishEditing
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $by4Mb.HelpCenterCustomizeSidebar), {
        isOpen: isCustomizing,
        onClose: handleFinishEditing
    })) : null), (0, $lFpPv.isUseHelpCenterRefresh)() && canAdministerJira && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8gC0T.default), {
        messageId: (0, $jcRK7.EngagementMessages).CHANGE_BOARD_VISUAL_REFRESH
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eDJg6.VisualRefreshChangeboarding), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bwdOx.SidebarToggle), {
        openSidebar: onOpen,
        closeSidebar: handleFinishEditing
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iydAA.FireScreenEventOnMount), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j2vrN.ExperienceSuccess), {
        location: "view-home-page"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2Wp8Q.HelpCenterRovoWidget), null))));
};
const $81392dea693523af$var$selector = (0, $BOq7h.createSelector)([
    (0, $aI0YR.getCanAdministerJIRA),
    (0, $44VoE.getShown),
    (0, $38uh5.isCustomizing)
], (canAdministerJira, searchBarShown, isCustomizing)=>({
        canAdministerJira: canAdministerJira,
        searchBarShown: searchBarShown,
        isCustomizing: isCustomizing
    }));
const $81392dea693523af$var$ConnectedViewHomepage = (0, $egQxE.connect)($81392dea693523af$var$selector, {
    onStartEditing: ()=>(0, $cywwP.editingHelpCenter)(true),
    onFinishEditing: ()=>(0, $cywwP.editingHelpCenter)(false)
})($81392dea693523af$var$ViewHomepage);
const $81392dea693523af$var$ViewHomePageLoader = ({ isLoading: isLoading, user: user })=>{
    const { queryReference: queryReference } = (0, $3LQyI.useRelayResource)((0, $k30kR.ViewHomepageResource));
    (0, $7WRjA.useUFOComponentExperience)((0, $3cWdD.viewHomepageExperience));
    (0, $7WRjA.useUFOComponentExperience)((0, $fIqDf.helpCenterTopicsProductExperience));
    const loginUrl = (0, $oORS9.getLoginUrl)({
        redirectUrl: '/portals'
    });
    // TODO: Move this to a lazy element error handler  to exclude from the main bundle
    const renderError = (0, $bSJIT.useCallback)((error)=>{
        const traceId = (0, $a6PX2.getTraceIdFromRelayQueryReference)(queryReference);
        const analyticsAttributes = {
            traceId: traceId,
            screenName: (0, $jcRK7.ScreenName).VIEW_HOMEPAGE,
            errorMessage: error.message,
            status: error.status
        };
        if (error.status === (0, $jcRK7.HTTP).UNAUTHORIZED) {
            // When redirecting to login page we need to make sure user is not already logged in else it will create a redirect loop
            if (!isLoading && !user.isLoggedIn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5lPCP.Redirect), {
                push: true,
                to: loginUrl
            });
        }
        if (!(0, $51XYw.isFetchNetworkOrClientError)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j2vrN.ExperienceFailure), {
            location: "view-home-page",
            errorMessage: error.message,
            traceId: traceId,
            status: error.status
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $81392dea693523af$var$errorScreenWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
            data: {
                attributes: analyticsAttributes
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hMmMY.GenericErrorScreen), null))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $81392dea693523af$var$errorScreenWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
            data: {
                attributes: analyticsAttributes
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hMmMY.GenericErrorScreen), null)));
    }, [
        loginUrl,
        queryReference,
        user,
        isLoading
    ]);
    if (!queryReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hO5qW.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gQQJs.LayoutNextErrorBoundary), {
        id: "root",
        renderError: renderError,
        screenName: (0, $jcRK7.ScreenName).VIEW_HOMEPAGE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJJTb.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hO5qW.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $6f79M.LayoutBuilderContainer), {
        ElementRenderer: (0, $lFpPv.isElementRendererSplitEnabled)() ? (0, $BkxYp.default) : undefined,
        screenName: (0, $jcRK7.ScreenName).VIEW_HOMEPAGE,
        traceId: (0, $a6PX2.getTraceIdFromRelayQueryReference)(queryReference),
        experience: (0, $3cWdD.viewHomepageExperience)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($81392dea693523af$var$ConnectedViewHomepage, {
        queryReference: queryReference
    })))));
};
const $81392dea693523af$var$homePageLoaderSelector = (0, $BOq7h.createSelector)((state)=>(0, $aI0YR.getUserState)(state), (userState)=>({
        user: {
            isLoggedIn: userState.isLoggedIn
        },
        isLoading: !userState.isLoaded
    }));
var $81392dea693523af$export$2e2bcd8739ae039 = (0, $egQxE.connect)($81392dea693523af$var$homePageLoaderSelector, {})((0, $fxMO5.withExperience)((0, $jcRK7.ExperienceName).HELP_CENTER)($81392dea693523af$var$ViewHomePageLoader));
// Added this to remove header and footer height and take the complete height for showing error
const $81392dea693523af$var$errorScreenWrapper = (0, $9BVpB.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: `calc(100vh - ${(0, $1DDTY.HEADER_HEIGHT) + (0, $hKa9R.FOOTER_HEIGHT)}px)`
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $81392dea693523af$var$LayoutViewerWrapper = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_kqswh2mm _n3tdxy5q",
            __cmplp.className
        ])
    });
});
const $81392dea693523af$var$HelpCenterBucketsContainer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $9fU1q.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eDJg6", function(module, exports) {
$parcel$export(module.exports, "VisualRefreshChangeboarding", () => $6b37753fdb83c284$export$c44cfe6f483e5337);

var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

const $6b37753fdb83c284$export$c44cfe6f483e5337 = (0, $cVM5r.default)({
    loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("9x0Js")), {
        moduleId: "./src/view/common/visual-refresh-changeboarding/visual-refresh-changeboarding.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("9x0Js", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("exU5E").then(()=>parcelRequire('lsfVx'));

});


parcelRegister("by4Mb", function(module, exports) {
$parcel$export(module.exports, "HelpCenterCustomizeSidebar", () => $5c715aa134ef200b$export$adc7aea328e0ddcc);

var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

const $5c715aa134ef200b$export$adc7aea328e0ddcc = (0, $cVM5r.default)({
    loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("lg3Vk")), {
        moduleId: "./src/view/help-center-customize-sidebar/hocs.tsx"
    })
});

});
parcelRegister("lg3Vk", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9Ncas"),
    $kOunM("j3XIh"),
    $kOunM("ednks"),
    $kOunM("968Ou")
]).then(()=>parcelRequire('ahoqj'));

});


parcelRegister("hMmMY", function(module, exports) {
$parcel$export(module.exports, "GenericErrorScreen", () => $87145e99d767193f$export$a2179166b0466c29);

var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

const $87145e99d767193f$export$a2179166b0466c29 = (0, $cVM5r.default)({
    loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("aZFl0")), {
        moduleId: "./src/view/layout-next/generic-error-screen/generic-error-screen.tsx"
    })
});

});
parcelRegister("aZFl0", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("imKO6").then(()=>parcelRequire('dXPUY'));

});


parcelRegister("a6PX2", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromRelayQueryReference", () => $70dab539e7f5ad37$export$4622b662a02532ee);
const $70dab539e7f5ad37$export$4622b662a02532ee = function(queryReference) {
    let traceId = undefined;
    if (queryReference) {
        var _queryReference$sourc;
        const subscription = (_queryReference$sourc = queryReference.source) === null || _queryReference$sourc === void 0 ? void 0 : _queryReference$sourc.subscribe({
            next: (rawResponse)=>{
                if ('extensions' in rawResponse) {
                    var _rawResponse$extensio;
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    const requestId = (_rawResponse$extensio = rawResponse.extensions) === null || _rawResponse$extensio === void 0 || (_rawResponse$extensio = _rawResponse$extensio.gateway) === null || _rawResponse$extensio === void 0 ? void 0 : _rawResponse$extensio.request_id;
                    if (requestId) traceId = requestId;
                }
            },
            error: ()=>{
            // keep this callback or fetch error will be throw as uncaught
            }
        });
        subscription === null || subscription === void 0 || subscription.unsubscribe();
    }
    return traceId;
};

});

parcelRegister("cNoX9", function(module, exports) {
$parcel$export(module.exports, "HomePageElementViewRenderer", () => (parcelRequire("BkxYp")).default);

var $BkxYp = parcelRequire("BkxYp");

});

parcelRegister("7PmsI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4cc4f07cac0242e$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $f4cc4f07cac0242e$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    genericHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'cv.advanced-help-center.view-homepage.error-page.generic.error.heading.non-final'
    },
    genericMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'cv.advanced-help-center.view-home-page.error-page.generic.error.message.non-final'
    },
    helpCenterTitle: {
        defaultMessage: '{helpCenterTitle} - Jira Service Management',
        description: 'Page title for help center landing page',
        id: 'cv.advanced-help-center.view-home-pager.page.title'
    }
});

});



parcelRegister("l5bvm", function(module, exports) {
$parcel$export(module.exports, "getEmojiProvider", () => $bb029d09482d8a6b$export$8210f5f78c0bcf27);

var $etCmN = parcelRequire("etCmN");

var $ePuyT = parcelRequire("ePuyT");

var $a6ENB = parcelRequire("a6ENB");
const $bb029d09482d8a6b$export$8210f5f78c0bcf27 = (0, $ePuyT.default)((isEmojiEnabled, fabricEmojiUrl)=>{
    if (isEmojiEnabled && fabricEmojiUrl) {
        const emojiResource = new (0, $etCmN.default)({
            providers: [
                {
                    url: `${fabricEmojiUrl}/emoji/standard`
                },
                {
                    url: `${fabricEmojiUrl}/emoji/atlassian`
                }
            ],
            allowUpload: false
        });
        return emojiResource.fetchEmojiProvider().then(()=>Promise.resolve(emojiResource)).catch((e)=>{
            (0, $a6ENB.reportError)(e);
            return Promise.reject(e);
        });
    }
    return undefined;
});

});

parcelRegister("eFyLM", function(module, exports) {
$parcel$export(module.exports, "PortalCardClient", () => $2b117e521c9167cf$export$f9fc5c7aa80e3e65);

var $tLWYq = parcelRequire("tLWYq");

var $oORS9 = parcelRequire("oORS9");

var $kUtMt = parcelRequire("kUtMt");
class $2b117e521c9167cf$export$f9fc5c7aa80e3e65 extends (0, $tLWYq.default) {
    async fetchData(url) {
        const issueKey = (0, $oORS9.parseIssueKeyFromUrl)(url);
        if (issueKey === null) // This doesn't look like Jira URL, so let's use native resolver
        return super.fetchData(url);
        // Suppressing existing violation. Please fix this.
        return (0, $kUtMt.getRequestSmartCardData)(issueKey).then(// eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (response)=>this.createResolveResponse(issueKey, response));
    }
    prefetchData() {
        return Promise.resolve(undefined);
    }
    constructor(...args){
        super(...args), /* eslint-disable  @typescript-eslint/no-explicit-any */ this.createResolveResponse = (issueKey, response)=>{
            return {
                meta: {
                    visibility: 'restricted',
                    access: 'granted',
                    auth: [],
                    definitionId: 'jira-native-resolve'
                },
                data: {
                    '@context': {
                        '@vocab': 'https://www.w3.org/ns/activitystreams#',
                        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
                        schema: 'http://schema.org/'
                    },
                    '@type': [
                        'atlassian:Task',
                        'Object'
                    ],
                    name: `${issueKey}: ${response.summary}`,
                    tag: {
                        name: response.status,
                        appearance: 'default'
                    },
                    url: response.url,
                    taskType: {
                        '@type': [
                            'Object',
                            'atlassian:TaskType'
                        ],
                        '@id': 'https://www.atlassian.com/#JiraCustomTaskType',
                        name: response.requestType.name
                    },
                    icon: {
                        '@type': 'Image',
                        url: response.requestType.iconUrl
                    },
                    generator: {
                        '@type': 'Application',
                        '@id': 'https://www.atlassian.com/#Jira',
                        name: 'Jira'
                    }
                }
            };
        };
    }
}

});
parcelRegister("kUtMt", function(module, exports) {
$parcel$export(module.exports, "canViewRequest", () => $459653c0427bd542$export$fcf9cdaf6dacff17);
$parcel$export(module.exports, "getRequestSmartCardData", () => $459653c0427bd542$export$7c3f0476ba399805);

var $llRGw = parcelRequire("llRGw");

var $eDcdn = parcelRequire("eDcdn");
const $459653c0427bd542$export$fcf9cdaf6dacff17 = (requestKey, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/${requestKey}/smartcard/canviewrequest`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri).map((ajaxResponse)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
        return ajaxResponse.response.canViewRequest;
    }).toPromise().catch((e)=>Promise.reject(e));
};
const $459653c0427bd542$export$7c3f0476ba399805 = (requestKey, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/${requestKey}/smartcard`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri).map((ajaxResponse)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return ajaxResponse.response;
    }).toPromise().catch((e)=>Promise.reject(e));
};

});


parcelRegister("8ksMy", function(module, exports) {
$parcel$export(module.exports, "default", () => $726be2662ff4e8c5$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $aI0YR = parcelRequire("aI0YR");

var $2Om65 = parcelRequire("2Om65");
const $726be2662ff4e8c5$var$selector = (0, $BOq7h.createSelector)((0, $aI0YR.isLoggedIn), (isUserLoggedIn)=>({
        isUserLoggedIn: isUserLoggedIn
    }));
var $726be2662ff4e8c5$export$2e2bcd8739ae039 = (0, $egQxE.connect)($726be2662ff4e8c5$var$selector, {})((0, $2Om65.default));

});
parcelRegister("2Om65", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecd6b30a110fe3a6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $acAb6 = parcelRequire("acAb6");

var $5VhGP = parcelRequire("5VhGP");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("9zszD");
var $fbK1P = parcelRequire("fbK1P");

var $3I5RS = parcelRequire("3I5RS");

var $eYvps = parcelRequire("eYvps");

var $edmwx = parcelRequire("edmwx");

var $cElD7 = parcelRequire("cElD7");

var $8eA76 = parcelRequire("8eA76");
const $ecd6b30a110fe3a6$var$convertSizeToIconSize = (size)=>{
    return size === 'small' ? 'small' : 'medium';
};
const $ecd6b30a110fe3a6$var$getFallbackIcon = ({ iconType: iconType, intl: intl, size: size })=>{
    const icon = "var(--ds-icon, #42526E)";
    switch(iconType){
        case 'REQUEST_FORM':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($edmwx))), {
                label: intl.formatMessage((0, $cElD7.default).externalResourceRequestFormIconLabel),
                size: $ecd6b30a110fe3a6$var$convertSizeToIconSize(size),
                color: icon
            });
        case 'ARTICLE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3I5RS))), {
                label: intl.formatMessage((0, $cElD7.default).externalResourceArticleIconLabel),
                size: $ecd6b30a110fe3a6$var$convertSizeToIconSize(size),
                color: icon,
                spacing: "spacious"
            });
        case 'CHANNEL':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eYvps))), {
                label: intl.formatMessage((0, $cElD7.default).externalResourceHelpChannelIconLabel),
                size: $ecd6b30a110fe3a6$var$convertSizeToIconSize(size),
                color: icon
            });
    }
};
const $ecd6b30a110fe3a6$var$getIcon = ({ isIconLoading: isIconLoading, iconUrl: iconUrl, resourceType: resourceType, intl: intl, size: size = 'large' })=>{
    if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5VhGP.SkeletonItem), {
        height: (0, $8eA76.iconDimension),
        width: (0, $8eA76.iconDimension)
    });
    if (iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $acAb6.default), {
        src: iconUrl,
        inheritWidth: true,
        draggable: false
    });
    return $ecd6b30a110fe3a6$var$getFallbackIcon({
        intl: intl,
        size: size,
        iconType: resourceType
    });
};
const $ecd6b30a110fe3a6$var$ExternalResourceIcon = (props)=>{
    const { data: data, isLoading: isLoading } = (0, $fbK1P.useExternalLinkIcon)({
        isLoggedIn: props.isUserLoggedIn,
        link: props.iconUrl || ''
    });
    return $ecd6b30a110fe3a6$var$getIcon({
        isIconLoading: isLoading,
        iconUrl: data || '',
        resourceType: props.resourceType,
        intl: props.intl,
        size: props.size
    });
};
var $ecd6b30a110fe3a6$export$2e2bcd8739ae039 = (0, $fK3tS.default)($ecd6b30a110fe3a6$var$ExternalResourceIcon);

});
parcelRegister("9zszD", function(module, exports) {
$parcel$export(module.exports, "useExternalLinkIcon", () => (parcelRequire("fbK1P")).useExternalLinkIcon);

var $fbK1P = parcelRequire("fbK1P");

});
parcelRegister("fbK1P", function(module, exports) {
$parcel$export(module.exports, "useExternalLinkIcon", () => $a6b771cef0a83715$export$3e74479e59c03d8b);

var $bSJIT = parcelRequire("bSJIT");

var $dyYIc = parcelRequire("dyYIc");

var $3qDrS = parcelRequire("3qDrS");
const $a6b771cef0a83715$export$2c4a28c399ed5beb = (urls)=>{
    return (0, $dyYIc.fetchObjectsFromUrls)(urls).toPromise().then((response)=>{
        return urls.reduce((ref, url, index)=>({
                ...ref,
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                [url]: response[index]
            }), {});
    });
};
const $a6b771cef0a83715$var$batchedFetchIcon = (0, $3qDrS.default)($a6b771cef0a83715$export$2c4a28c399ed5beb, 0);
const $a6b771cef0a83715$export$89d9bd8ccd64e87c = {};
const $a6b771cef0a83715$var$addIconToCache = (key, value)=>{
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    $a6b771cef0a83715$export$89d9bd8ccd64e87c[key] = value;
};
function $a6b771cef0a83715$export$3e74479e59c03d8b({ isLoggedIn: isLoggedIn, link: url }) {
    const [data, setData] = (0, $bSJIT.useState)(null);
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(true);
    const markDataLoaded = (key, value)=>{
        setIsLoading(false);
        setData(value);
        $a6b771cef0a83715$var$addIconToCache(key, value);
    };
    (0, $bSJIT.useEffect)(()=>{
        let href = url;
        if (!isLoggedIn) {
            markDataLoaded(url, null);
            return;
        }
        /**
     * Try to parse the url and extract out the href
     * if it fails return null as the icon url
     */ try {
            href = new URL(url).href;
        } catch (error) {
            markDataLoaded(url, null);
            return;
        }
        /**
     * Origin is null for other supported url forms like `tel:` and `mail:`
     * return null so that ui can fallback to default icons
     */ if (new URL(url).origin === 'null') {
            markDataLoaded(url, null);
            return;
        }
        /**
     * check is there is already entry in cache
     * if yes, return the icon url
     * else, make a call to object resolver service
     */ if (Object.keys($a6b771cef0a83715$export$89d9bd8ccd64e87c).includes(href)) {
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const iconUrl = $a6b771cef0a83715$export$89d9bd8ccd64e87c[href];
            setData(iconUrl);
            setIsLoading(false);
        } else $a6b771cef0a83715$var$batchedFetchIcon(href).then((response)=>{
            var _response$href;
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            const iconUrl = (_response$href = response[href]) === null || _response$href === void 0 || (_response$href = _response$href.body) === null || _response$href === void 0 || (_response$href = _response$href.data) === null || _response$href === void 0 || (_response$href = _response$href.generator) === null || _response$href === void 0 || (_response$href = _response$href.icon) === null || _response$href === void 0 ? void 0 : _response$href.url;
            markDataLoaded(href, iconUrl ?? null);
        }).catch(()=>{
            return null;
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        isLoggedIn,
        url
    ]);
    return {
        data: data,
        isLoading: isLoading
    };
}

});


parcelRegister("cElD7", function(module, exports) {
$parcel$export(module.exports, "default", () => $a106a8d1db0f0338$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $a106a8d1db0f0338$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    externalResourceRequestFormIconLabel: {
        id: 'cv.external-resource-fallback-icon.external-link-request-form-icon-label',
        defaultMessage: 'Request form',
        description: 'Label for Request form external link icon'
    },
    externalResourceArticleIconLabel: {
        id: 'cv.external-resource-fallback-icon.external-link-knowledge-icon-label',
        defaultMessage: 'Article',
        description: 'Label for knowledge article external link icon'
    },
    externalResourceHelpChannelIconLabel: {
        id: 'cv.external-resource-fallback-icon.external-link-help-channel-icon-label',
        defaultMessage: 'Help channel',
        description: 'Label for channel external link icon'
    }
});

});

parcelRegister("8eA76", function(module, exports) {
$parcel$export(module.exports, "iconDimension", () => $4588c25b89fefebd$export$3b332b9dae1acea2);

var $9K7mZ = parcelRequire("9K7mZ");
const $4588c25b89fefebd$export$3b332b9dae1acea2 = $9K7mZ.multiple(3).px;

});



parcelRegister("bsfOD", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $401faecf6214db6a$export$ef2184bd89960b14);
/* grid.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jCkxO = parcelRequire("jCkxO");

var $gvlgq = parcelRequire("gvlgq");
const $401faecf6214db6a$var$baseStyles = null;
const $401faecf6214db6a$var$gapMediaQueries = null;
const $401faecf6214db6a$var$inlinePaddingMediaQueries = null;
const $401faecf6214db6a$var$gridMaxWidthMap = {
    wide: "_p12f1ng1",
    narrow: "_p12f3l0t"
};
const $401faecf6214db6a$var$GridContext = /*#__PURE__*/ (0, $bSJIT.createContext)(false);
const $401faecf6214db6a$export$ef2184bd89960b14 = ({ testId: testId, children: children, maxWidth: maxWidth, hasInlinePadding: hasInlinePadding })=>{
    const isNested = (0, $bSJIT.useContext)($401faecf6214db6a$var$GridContext);
    const isWithinContainer = (0, $bSJIT.useContext)((0, $gvlgq.GridContainerContext));
    // while not within a GridContainer hasInlinePadding either undefined or true means setting the padding on by default
    const showInlinePadding = hasInlinePadding !== false;
    (0, $jCkxO.default)(!isNested, '@atlaskit/grid: Nesting grids are not supported at this time, please only use a top-level grid or leverage GridContainer.');
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_195g1wug _1e0c11p5 _vchhusvi _1bsb1osq _yv0ecx6w",
            "_zulppxbi _1t5cpxbi _19wgpxbi _pdlm1ejb _a64kxy5q _rciaxy5q",
            !isWithinContainer && maxWidth && $401faecf6214db6a$var$gridMaxWidthMap[maxWidth],
            !isWithinContainer && showInlinePadding && "_18zrpxbi _yhr2pxbi _su071ejb _owpuxy5q _ecdxxy5q _1oef1jfw"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($401faecf6214db6a$var$GridContext.Provider, {
            value: true,
            children: children
        })
    });
};

});
parcelRegister("gvlgq", function(module, exports) {
$parcel$export(module.exports, "GridContainerContext", () => $919d9d59100872bc$export$c4b87de305f87814);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");
const $919d9d59100872bc$export$c4b87de305f87814 = /*#__PURE__*/ (0, $bSJIT.createContext)(false);

});


parcelRegister("365Qe", function(module, exports) {
$parcel$export(module.exports, "GridItem", () => $8b7c89ef6f9033cb$export$9eb849b9b922d396);
/* grid-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
// when in doubt simply span all columns
const $8b7c89ef6f9033cb$var$baseGridItemStyles = null;
const $8b7c89ef6f9033cb$var$hideMediaQueries = {
    xxs: "_1e0cglyw",
    xs: "_114bglyw",
    sm: "_181nglyw",
    md: "_dm25glyw",
    lg: "_je3oglyw",
    xl: "_1uxvglyw"
};
const $8b7c89ef6f9033cb$var$gridSpanMediaQueries = {
    xxs: "_1e0c1ule _f0zu1upc",
    xs: "_114b1ule _39j2137j",
    sm: "_181n1ule _1q5l4pyr",
    md: "_dm251ule _eao7ipnf",
    lg: "_je3o1ule _1q0qr2jm",
    xl: "_1uxv1ule _9wod1jef"
};
const $8b7c89ef6f9033cb$var$gridStartMediaQueries = {
    xxs: "_14611tz4",
    xs: "_1neypgh2",
    sm: "_dz5juzyq",
    md: "_uhi518lg",
    lg: "_1y10117f",
    xl: "_c0ud1l89"
};
/**
 * Build a set of responsive css variables given a responsive object
 * to be set via `props.style`
 */ function $8b7c89ef6f9033cb$var$buildCSSVarsFromConfig({ responsiveObject: responsiveObject, key: key, prefix: prefix, isValidBreakpointValue: isValidBreakpointValue = ()=>true }) {
    /**
   * This coerces an object of `{ xxs: 12, sm: 'auto', … }` down to `[['xxs', 12], ['sm', 'auto], …]`.  Split out for readability.
   */ const entries = Object.entries(responsiveObject);
    return entries.reduce((acc, [breakpoint, value])=>{
        if (typeof value === 'undefined' || !isValidBreakpointValue(value)) return acc;
        return {
            ...acc,
            [`--${prefix}-${String(breakpoint)}-${key}`]: value
        };
    }, {});
}
const $8b7c89ef6f9033cb$export$9eb849b9b922d396 = ({ testId: testId, children: children, start: startProp = 'auto', span: spanProp = 12 })=>{
    // If `prop` isn't a responsive object, we set the value against the `xs` breakpoint, eg. `span={6}` is the same as `span={{ xxs: 6 }}`
    const span = typeof spanProp === 'object' ? spanProp : {
        xxs: spanProp
    };
    const spanDependencyComparison = JSON.stringify(span); // to compare `span` changes in a `useMemo` deps array (used a few times)
    const spanStyles = (0, $bSJIT.useMemo)(()=>$8b7c89ef6f9033cb$var$buildCSSVarsFromConfig({
            responsiveObject: span,
            key: 'span',
            prefix: 'grid-item',
            // We don't want a css var like `--grid-item-xs-span: none` as it's invalid and unused.
            isValidBreakpointValue: (value)=>value !== 'none'
        }), // eslint-disable-next-line react-hooks/exhaustive-deps -- `span` will change references easily, but we still need to allow content or key changes to update
    [
        spanDependencyComparison
    ]);
    // If `prop` isn't a responsive object, we set the value against the `xs` breakpoint, eg. `start={6}` is the same as `start={{ xxs: 6 }}`
    const start = typeof startProp === 'object' ? startProp : {
        xxs: startProp
    };
    const startDependencyComparison = JSON.stringify(start); // to compare `start` changes in a `useMemo` deps array (used a few times)
    const startStyles = (0, $bSJIT.useMemo)(()=>$8b7c89ef6f9033cb$var$buildCSSVarsFromConfig({
            responsiveObject: start,
            key: 'start',
            prefix: 'grid-item'
        }), // eslint-disable-next-line react-hooks/exhaustive-deps -- `start` will change references easily, but we still need to allow content or key changes to update
    [
        startDependencyComparison
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...startStyles,
            ...spanStyles
        },
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            "_yyhy13k5",
            span.xxs && span.xxs === 'none' && $8b7c89ef6f9033cb$var$hideMediaQueries.xxs,
            span.xxs && span.xxs !== 'none' && $8b7c89ef6f9033cb$var$gridSpanMediaQueries.xxs,
            start.xxs && $8b7c89ef6f9033cb$var$gridStartMediaQueries.xxs,
            span.xs && span.xs === 'none' && $8b7c89ef6f9033cb$var$hideMediaQueries.xs,
            span.xs && span.xs !== 'none' && $8b7c89ef6f9033cb$var$gridSpanMediaQueries.xs,
            start.xs && $8b7c89ef6f9033cb$var$gridStartMediaQueries.xs,
            span.sm && span.sm === 'none' && $8b7c89ef6f9033cb$var$hideMediaQueries.sm,
            span.sm && span.sm !== 'none' && $8b7c89ef6f9033cb$var$gridSpanMediaQueries.sm,
            start.sm && $8b7c89ef6f9033cb$var$gridStartMediaQueries.sm,
            span.md && span.md === 'none' && $8b7c89ef6f9033cb$var$hideMediaQueries.md,
            span.md && span.md !== 'none' && $8b7c89ef6f9033cb$var$gridSpanMediaQueries.md,
            start.md && $8b7c89ef6f9033cb$var$gridStartMediaQueries.md,
            span.lg && span.lg === 'none' && $8b7c89ef6f9033cb$var$hideMediaQueries.lg,
            span.lg && span.lg !== 'none' && $8b7c89ef6f9033cb$var$gridSpanMediaQueries.lg,
            start.lg && $8b7c89ef6f9033cb$var$gridStartMediaQueries.lg,
            span.xl && span.xl === 'none' && $8b7c89ef6f9033cb$var$hideMediaQueries.xl,
            span.xl && span.xl !== 'none' && $8b7c89ef6f9033cb$var$gridSpanMediaQueries.xl,
            start.xl && $8b7c89ef6f9033cb$var$gridStartMediaQueries.xl
        ]),
        children: children
    });
};

});

parcelRegister("4pSON", function(module, exports) {
$parcel$export(module.exports, "lightenHexColor", () => $4deee98647f4b559$export$2ed02d92bc7660d7);
function $4deee98647f4b559$export$2ed02d92bc7660d7(hexColor, lightenFactor) {
    // Remove '#' if present
    if (!hexColor) return null;
    const color = hexColor.replace('#', '');
    // Convert hex to RGB
    const red = parseInt(color.substring(0, 2), 16);
    const green = parseInt(color.substring(2, 4), 16);
    const blue = parseInt(color.substring(4, 6), 16);
    // Lighten the color (You can adjust the lighten factor as needed)
    const newRed = Math.floor((1 - lightenFactor) * red + lightenFactor * 255);
    const newGreen = Math.floor((1 - lightenFactor) * green + lightenFactor * 255);
    const newBlue = Math.floor((1 - lightenFactor) * blue + lightenFactor * 255);
    // Ensure the values are within 0-255 range
    const adjustedRed = Math.max(0, Math.min(255, newRed));
    const adjustedGreen = Math.max(0, Math.min(255, newGreen));
    const adjustedBlue = Math.max(0, Math.min(255, newBlue));
    // Convert adjusted RGB back to hex
    return `#${adjustedRed.toString(16).padStart(2, '0')}${adjustedGreen.toString(16).padStart(2, '0')}${adjustedBlue.toString(16).padStart(2, '0')}`;
}

});

parcelRegister("4WPlN", function(module, exports) {
$parcel$export(module.exports, "CSMSupportWidgetConfigProvider", () => $03b6c127b80bd1a2$export$4836a4111c27cf5d);
$parcel$export(module.exports, "CSMSupportSiteAiSearchTrigger", () => $03b6c127b80bd1a2$export$1c93edf13856888c);
$parcel$export(module.exports, "CSMSupportAgent", () => $03b6c127b80bd1a2$export$c7aaa689c820ac8f);
$parcel$export(module.exports, "withAiAgent", () => $03b6c127b80bd1a2$export$d3e544617e610e0f);

var $bSJIT = parcelRequire("bSJIT");

var $fT4XN = parcelRequire("fT4XN");

var $lFpPv = parcelRequire("lFpPv");

var $4vLTk = parcelRequire("4vLTk");

var $2bmUD = parcelRequire("2bmUD");

var $lJzMO = parcelRequire("lJzMO");

var $87QgR = parcelRequire("87QgR");

var $hkLEY = parcelRequire("hkLEY");

var $jEvhx = parcelRequire("jEvhx");

var $eMSqH = parcelRequire("eMSqH");

var $2di5C = parcelRequire("2di5C");

var $kU7ap = parcelRequire("kU7ap");

var $3LQyI = parcelRequire("3LQyI");

var $jeKVR = parcelRequire("jeKVR");

var $6viDb = parcelRequire("6viDb");

var $3yGKh = parcelRequire("3yGKh");
const $03b6c127b80bd1a2$var$DEFAULT_BRANDING_COLOR = '#0074e0';
const $03b6c127b80bd1a2$export$4836a4111c27cf5d = ({ children: children })=>{
    const { queryReference: queryReference } = (0, $3LQyI.useRelayResource)((0, $6viDb.csmSupportWidgetConfigQueryResource));
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jeKVR.SupportWidgetConfigPreloadedQueryProvider), {
        queryReference: queryReference
    }, children);
};
const $03b6c127b80bd1a2$export$1c93edf13856888c = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $eMSqH.useAiWidgetConfig)();
    const { locale: locale } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jEvhx.AiSearchTrigger), {
        locale: (0, $87QgR.default).checkGate('csm_widget_embed_i18n') ? locale : undefined,
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId,
        widgetTheme: supportWidgetConfig.widgetTheme
    });
};
const $03b6c127b80bd1a2$export$32f8940f0b9a860e = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $eMSqH.useAiWidgetConfig)();
    const { locale: locale } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jEvhx.AiSearchTriggerFloating), {
        locale: (0, $87QgR.default).checkGate('csm_widget_embed_i18n') ? locale : undefined,
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId,
        widgetTheme: supportWidgetConfig.widgetTheme
    });
};
const $03b6c127b80bd1a2$export$ef203bd1d44751b9 = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $eMSqH.useAiWidgetConfig)();
    const { locale: locale } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2di5C.AiCornerAgent), {
        locale: (0, $87QgR.default).checkGate('csm_widget_embed_i18n') ? locale : undefined,
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId
    });
};
const $03b6c127b80bd1a2$export$c7aaa689c820ac8f = ()=>{
    const contextValue = (0, $eMSqH.useOptionalAiWidgetConfig)();
    if (!contextValue || !contextValue.supportWidgetConfig.isEnabled) return null;
    if (contextValue.supportWidgetConfig.widgetPosition === 'CORNER') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($03b6c127b80bd1a2$export$ef203bd1d44751b9, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($03b6c127b80bd1a2$export$32f8940f0b9a860e, null);
};
const $03b6c127b80bd1a2$var$WidgetErrorBoundary = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const renderError = (0, $bSJIT.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lJzMO.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2bmUD.default), {
            id: "csm-widget-error-flag",
            appearance: "error",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
                label: ""
            }),
            title: formatMessage((0, $3yGKh.default).widgetErrorTitle),
            description: formatMessage((0, $3yGKh.default).widgetErrorDescription),
            testId: "csm-widget-error-flag"
        }));
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        packageName: "csm-chat-widget",
        id: "widget-config-provider",
        renderError: renderError
    }, children);
};
const $03b6c127b80bd1a2$export$d3e544617e610e0f = (WrappedComponent, bannerText, showBanner = false)=>{
    const WithAiAgent = (props)=>{
        const { bannerBackgroundColor: bannerBackgroundColor = $03b6c127b80bd1a2$var$DEFAULT_BRANDING_COLOR, ...componentProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Fragment), null, (0, $lFpPv.isHubsEnabledInHelpCenter)() && showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($03b6c127b80bd1a2$export$4836a4111c27cf5d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kU7ap.CsmBanner), {
            bannerBackgroundColor: bannerBackgroundColor,
            bannerText: bannerText
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrappedComponent, componentProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($03b6c127b80bd1a2$var$WidgetErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($03b6c127b80bd1a2$export$4836a4111c27cf5d, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($03b6c127b80bd1a2$export$c7aaa689c820ac8f, null)))));
    };
    WithAiAgent.displayName = `WithAiAgent(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return WithAiAgent;
};

});
parcelRegister("kU7ap", function(module, exports) {
$parcel$export(module.exports, "CsmBanner", () => $2246f10d7604b126$export$a991b344a21beb63);
/* csm-banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $9cDCX = parcelRequire("9cDCX");

var $4vLTk = parcelRequire("4vLTk");

var $87QgR = parcelRequire("87QgR");

var $jEvhx = parcelRequire("jEvhx");

var $eMSqH = parcelRequire("eMSqH");
const $2246f10d7604b126$var$textContainerStyles = null;
const $2246f10d7604b126$var$outerStackWrapperStyles = null;
const $2246f10d7604b126$var$bannerTextStyles = null;
const $2246f10d7604b126$var$wrapperStyles = null;
const $2246f10d7604b126$var$bannerStyles = null;
const $2246f10d7604b126$var$aiSearchTriggerStyles = null;
const $2246f10d7604b126$export$a991b344a21beb63 = ({ bannerText: bannerText, bannerBackgroundColor: bannerBackgroundColor })=>{
    const aiWidgetConfig = (0, $eMSqH.useOptionalAiWidgetConfig)();
    const { formatMessage: formatMessage, locale: locale } = (0, $4vLTk.default)();
    const widgetLocale = (0, $87QgR.default).checkGate('csm_widget_embed_i18n') ? locale : undefined;
    const renderAiTriggerWithBanner = aiWidgetConfig && aiWidgetConfig.supportWidgetConfig.isEnabled && aiWidgetConfig.supportWidgetConfig.widgetPosition === 'CENTER';
    let bannerTextToDisplay = '';
    if (bannerText && typeof bannerText === 'string') bannerTextToDisplay = bannerText;
    else if (bannerText && typeof bannerText === 'object') bannerTextToDisplay = formatMessage(bannerText);
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _2lx21bp4"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        style: {
            backgroundColor: bannerBackgroundColor
        },
        "data-testid": "csm-banner",
        className: (0, $9fU1q.default)([
            "_2rko12b0 _ca0q1epz _n3td1epz _18u01ejb _2hwx1ejb _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": "csm-banner-outer-stack-wrapper",
        className: (0, $9fU1q.default)([
            "_1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": "csm-banner-text-container",
        className: (0, $9fU1q.default)([
            "_4t3i8vuz _1wpz1h6o _10fp1h6o _1bsb1vuk"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": "banner-text",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            color: (0, $9cDCX.readableTextColor)(bannerBackgroundColor)
        },
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _k48pmoej _1wybckbl _vwz48vuz _o5721q9c _1bto1l2s _1bsb1osq _y3gn1h6o"
        ])
    }, bannerTextToDisplay)))), renderAiTriggerWithBanner && /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-testid": "ai-search-trigger-container",
        className: (0, $9fU1q.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _t9ec1i34"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $jEvhx.AiSearchTrigger), {
        locale: widgetLocale,
        site: aiWidgetConfig.supportWidgetConfig.site,
        siteId: aiWidgetConfig.supportWidgetConfig.siteId,
        widgetId: aiWidgetConfig.supportWidgetConfig.widgetId,
        widgetTheme: aiWidgetConfig.supportWidgetConfig.widgetTheme
    })));
};

});

parcelRegister("jeKVR", function(module, exports) {
$parcel$export(module.exports, "SupportWidgetConfigPreloadedQueryProvider", () => $c297dc80f8532544$export$7d442fdc514d6481);

var $bGVpb = parcelRequire("bGVpb");

var $bSJIT = parcelRequire("bSJIT");

var $fuVmc = parcelRequire("fuVmc");

var $a2qIF = parcelRequire("a2qIF");

var $eMSqH = parcelRequire("eMSqH");

var $hGDAA = parcelRequire("hGDAA");
const $c297dc80f8532544$export$7d442fdc514d6481 = ({ queryReference: queryReference, children: children })=>{
    var _data$helpCenter;
    const data = (0, $a2qIF.usePreloadedQuery)((0, $bGVpb.default), queryReference);
    const primaryColor = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterBranding) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.colors) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.primary;
    const widgetConfig = data.csmAi_getSupportWidget;
    const siteId = (0, $fuVmc.getMeta)('tenant-id');
    const supportWidgetConfig = (0, $bSJIT.useMemo)(()=>{
        if (!widgetConfig || !widgetConfig.id || !widgetConfig.theme || !primaryColor || !siteId) return null;
        return {
            siteId: siteId,
            widgetId: widgetConfig.id,
            widgetTheme: {
                primaryColor: primaryColor,
                radius: (0, $hGDAA.handleWidgetRadiusType)(widgetConfig.theme.radius),
                space: (0, $hGDAA.handleWidgetSpaceType)(widgetConfig.theme.space),
                chatBubbleVariant: (0, $hGDAA.handleChatBubbleVariant)(widgetConfig.theme.chatColor),
                widgetButtonVariant: (0, $hGDAA.handleWidgetButtonVariant)(widgetConfig.theme.colorVibeVariant),
                attribution: null
            },
            widgetPosition: (0, $hGDAA.handleWidgetPosition)(widgetConfig.position),
            isEnabled: Boolean(widgetConfig.isEnabled)
        };
    }, [
        widgetConfig,
        primaryColor,
        siteId
    ]);
    if (!supportWidgetConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Fragment), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eMSqH.AiWidgetConfigProvider), {
        supportWidgetConfig: supportWidgetConfig
    }, children);
};

});
parcelRegister("hGDAA", function(module, exports) {
$parcel$export(module.exports, "handleWidgetRadiusType", () => $b4d17ddfc5768e05$export$21feeed55533391b);
$parcel$export(module.exports, "handleWidgetSpaceType", () => $b4d17ddfc5768e05$export$882cd7667f1dc36b);
$parcel$export(module.exports, "handleWidgetPosition", () => $b4d17ddfc5768e05$export$565c45f827c88f12);
$parcel$export(module.exports, "handleChatBubbleVariant", () => $b4d17ddfc5768e05$export$8d7135a196764ba5);
$parcel$export(module.exports, "handleWidgetButtonVariant", () => $b4d17ddfc5768e05$export$1e1d4315fa0edb5);
const $b4d17ddfc5768e05$export$21feeed55533391b = (radius)=>{
    switch(radius){
        case 'ROUNDED':
            return 'rounded';
        case 'SHARP':
            return 'sharp';
        case 'NORMAL':
        default:
            return 'normal';
    }
};
const $b4d17ddfc5768e05$export$882cd7667f1dc36b = (space)=>{
    switch(space){
        case 'COSY':
            return 'cosy';
        case 'GENEROUS':
            return 'generous';
        case 'COMFORTABLE':
        default:
            return 'comfortable';
    }
};
const $b4d17ddfc5768e05$export$565c45f827c88f12 = (position)=>{
    switch(position){
        case 'CENTER':
            return 'CENTER';
        case 'CORNER':
        default:
            return 'CORNER';
    }
};
const $b4d17ddfc5768e05$export$8d7135a196764ba5 = (variant)=>{
    switch(variant){
        case 'LIGHT':
            return 'light';
        case 'DARK':
            return 'dark';
        case 'VIBRANT':
            return 'vibrant';
        case 'DEFAULT':
        default:
            return 'default';
    }
};
const $b4d17ddfc5768e05$export$1e1d4315fa0edb5 = (variant)=>{
    switch(variant){
        case 'LIGHT':
            return 'light';
        case 'DARK':
            return 'dark';
        case 'VIBRANT':
            return 'vibrant';
        case 'DEFAULT':
        default:
            return 'dark';
    }
};

});


parcelRegister("3yGKh", function(module, exports) {
$parcel$export(module.exports, "default", () => $40189681650ac149$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $40189681650ac149$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    widgetErrorTitle: {
        id: 'csm.chat-widget.error-boundary.title',
        defaultMessage: 'Support widget unavailable',
        description: 'Title for the error flag for when the widget failed to load'
    },
    widgetErrorDescription: {
        id: 'csm.chat-widget.error-boundary.description',
        defaultMessage: 'The AI Agent failed to load. Please refresh the page to try again.',
        description: 'Description for the error flag for when the widget failed to load'
    }
});

});


parcelRegister("dypvL", function(module, exports) {
$parcel$export(module.exports, "customScreenSizeBig", () => $9b60440fc3d4ed13$export$2d7651bab1441300);
$parcel$export(module.exports, "Title", () => $9b60440fc3d4ed13$export$f99233281efd08a0);
$parcel$export(module.exports, "portalCardsContainerStyle", () => $9b60440fc3d4ed13$export$32710fa1aefc7868);
$parcel$export(module.exports, "portalCardsContainerWithSidebarStyle", () => $9b60440fc3d4ed13$export$6cc470cc78fa25c9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $58A3x = parcelRequire("58A3x");

var $ki6Qt = parcelRequire("ki6Qt");

var $7QbH4 = parcelRequire("7QbH4");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");
const $9b60440fc3d4ed13$export$1d7dbfbc152a1f2d = (110 + (0, $58A3x.SIDEBAR_WIDTH_LARGE_MULTIPLIER)) * 8;
const $9b60440fc3d4ed13$export$2d7651bab1441300 = (155 + (0, $58A3x.SIDEBAR_WIDTH_LARGE_MULTIPLIER)) * 8;
const $9b60440fc3d4ed13$export$cf9cf37dc6d93b93 = /*#__PURE__*/ (0, $4v2A7.css)`margin-left:${"var(--ds-space-400, 32px)"};padding-left:${"var(--ds-space-050, 4px)"};${$ki6Qt.fromXSmall.css`
    margin-left: 0;
    `};`;
const $9b60440fc3d4ed13$export$f99233281efd08a0 = /*#__PURE__*/ (0, $4v2A7.default).h2.withConfig({
    componentId: "sc-wl1xz3-0"
})`${$98sDU.h500};color:${({ textColor: textColor })=>textColor};align-self:flex-start;box-sizing:border-box;margin:${"var(--ds-space-250, 20px)"} auto ${"var(--ds-space-200, 16px)"} 0;${$9b60440fc3d4ed13$export$cf9cf37dc6d93b93}`;
const $9b60440fc3d4ed13$export$32710fa1aefc7868 = /*#__PURE__*/ (0, $4v2A7.css)`max-width:${$9K7mZ.multiple(42).px};${$ki6Qt.fromMedium.css`
        max-width: ${$9K7mZ.multiple(90).px};
    `} ${$ki6Qt.fromLarge.css`
        max-width: ${$9K7mZ.multiple(145).px};
    `}`;
const $9b60440fc3d4ed13$export$6cc470cc78fa25c9 = /*#__PURE__*/ (0, $4v2A7.css)`max-width:${$9K7mZ.multiple(42).px};${$ki6Qt.fromCustom($9b60440fc3d4ed13$export$1d7dbfbc152a1f2d).css`
        max-width: ${$9K7mZ.multiple(90).px};
    `} ${$ki6Qt.fromCustom($9b60440fc3d4ed13$export$2d7651bab1441300).css`
        max-width: ${$9K7mZ.multiple(145).px};
    `}`;
const $9b60440fc3d4ed13$export$e4ecc4389889ce72 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-wl1xz3-1"
})`width:${$9K7mZ.multiple(33).px};margin-left:auto;margin-right:auto;${$ki6Qt.fromXSmall.css`
        width: 100%;
    `};${$ki6Qt.fromMedium.css`
        width: ${({ count: count })=>{
    if (count > 1) return '100%';
    return `${$9K7mZ.multiple(42).px}`;
}};
        margin-left: 0;
    `};margin-top:${"var(--ds-space-400, 32px)"};border-radius:${$fU62V.borderRadiusValue};background-color:${"var(--ds-surface-raised, #FFFFFF)"};${$7QbH4.e100}`;
const $9b60440fc3d4ed13$export$2af90d9489a98eb1 = /*#__PURE__*/ (0, $4v2A7.default).ol.withConfig({
    componentId: "sc-wl1xz3-2"
})`box-sizing:border-box;list-style-type:none;display:flex;flex-flow:row wrap;width:100%;padding:${"var(--ds-space-200, 16px)"};& > li{flex:0 0 100%;}`;
const $9b60440fc3d4ed13$export$c2735e89f513ed7a = /*#__PURE__*/ (0, $4v2A7.default).ul.withConfig({
    componentId: "sc-wl1xz3-3"
})`box-sizing:border-box;list-style-type:none;display:flex;flex-flow:row wrap;width:100%;padding:${"var(--ds-space-200, 16px)"};& > li{flex:0 0 100%;}`;

});

parcelRegister("ctlzt", function(module, exports) {
$parcel$export(module.exports, "default", () => $919b5b830e7b63bc$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $919b5b830e7b63bc$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    exploreAll: {
        defaultMessage: 'Show more portals ({remainingCount, number})',
        description: 'Text message for Explore all button to load additional project cards',
        id: 'cv.portal.card.layout.list.explore.all.button'
    },
    collapseOtherProjects: {
        defaultMessage: 'Show fewer',
        description: 'Text message for Collapse other projects button to collapse other projects section',
        id: 'cv.portal.card.layout.list.collapse.button'
    },
    featuredPortalsLabel: {
        defaultMessage: 'Featured portals',
        description: 'Text message for featured portals section',
        id: 'cv.portal.card.layout.list.featured.portals.title'
    },
    remainingProjectsByName: {
        defaultMessage: 'More portals',
        description: 'The text is shown as the section heading for additional portals listed alphabetically by name in the featured and sorted portals card list on the help center home page.',
        id: 'cv.portal.card.layout.list.remaining.projects.by.name.title'
    },
    remainingPortals: {
        defaultMessage: 'Portals',
        description: 'The text is shown as the section heading for the remaining portals list in the help center home page when no specific sort order is applied.',
        id: 'cv.portal.card.layout.list.remaining.portals'
    }
});

});

parcelRegister("jHj1h", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $e570c95b97b66247$export$2f62ee6831462844);

var $bSJIT = parcelRequire("bSJIT");
"use client";
var $e570c95b97b66247$var$__defProp = Object.defineProperty;
var $e570c95b97b66247$var$__defNormalProp = (obj, key, value)=>key in obj ? $e570c95b97b66247$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e570c95b97b66247$var$__publicField = (obj, key, value)=>{
    $e570c95b97b66247$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/observe.ts
var $e570c95b97b66247$var$observerMap = /* @__PURE__ */ new Map();
var $e570c95b97b66247$var$RootIds = /* @__PURE__ */ new WeakMap();
var $e570c95b97b66247$var$rootId = 0;
var $e570c95b97b66247$var$unsupportedValue = void 0;
function $e570c95b97b66247$export$2ef3a60ee1f37bec(inView) {
    $e570c95b97b66247$var$unsupportedValue = inView;
}
function $e570c95b97b66247$var$getRootId(root) {
    if (!root) return "0";
    if ($e570c95b97b66247$var$RootIds.has(root)) return $e570c95b97b66247$var$RootIds.get(root);
    $e570c95b97b66247$var$rootId += 1;
    $e570c95b97b66247$var$RootIds.set(root, $e570c95b97b66247$var$rootId.toString());
    return $e570c95b97b66247$var$RootIds.get(root);
}
function $e570c95b97b66247$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $e570c95b97b66247$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $e570c95b97b66247$var$createObserver(options) {
    const id = $e570c95b97b66247$var$optionsToId(options);
    let instance = $e570c95b97b66247$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $e570c95b97b66247$var$observerMap.set(id, instance);
    }
    return instance;
}
function $e570c95b97b66247$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $e570c95b97b66247$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $e570c95b97b66247$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $e570c95b97b66247$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $e570c95b97b66247$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $e570c95b97b66247$export$a62107ca74432f44 = class extends $bSJIT.Component {
    constructor(props){
        super(props);
        $e570c95b97b66247$var$__publicField(this, "node", null);
        $e570c95b97b66247$var$__publicField(this, "_unobserveCb", null);
        $e570c95b97b66247$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $e570c95b97b66247$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$e570c95b97b66247$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $e570c95b97b66247$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $bSJIT.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $e570c95b97b66247$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $bSJIT.useState(null);
    const callback = $bSJIT.useRef();
    const [state, setState] = $bSJIT.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $bSJIT.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $e570c95b97b66247$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $bSJIT.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});


//# sourceMappingURL=async-view-homepage.4b65960d.js.map
